var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftvouchersBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:gift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Light-New-Icons",
    transform: "translate(-15, -660)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:gift",
    transform: "translate(13, 658)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,15 L28,26 C28,27.1045695 27.1045695,28 26,28 L7,28 C5.8954305,28 5,27.1045695 5,26 L5,15 M16,6.5 C16,4.56700338 14.4329966,3 12.5,3 C10.5670034,3 9,4.56700338 9,6.5 C9,8.43299662 10.5670034,10 12.5,10 L16,10 M16,6.5 L16,10 M16,6.5 C16,4.56700338 17.5670034,3 19.5,3 C21.4329966,3 23,4.56700338 23,6.5 C23,8.43299662 21.4329966,10 19.5,10 L16,10 M16,10 L16,28 M4.5,15 L28.5,15 C29.328,15 30,14.328 30,13.5 L30,11.5 C30,10.672 29.328,10 28.5,10 L4.5,10 C3.672,10 3,10.672 3,11.5 L3,13.5 C3,14.328 3.672,15 4.5,15 Z",
    id: "Shape",
    stroke: "#192340",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftvouchersBlack);
export default __webpack_public_path__ + "static/media/giftvouchers-black.ae04a5c6297ac30878237677817ee3d4.svg";
export { ForwardRef as ReactComponent };